module.exports = __webpack_public_path__ + "img/组 7.d1c3e574.png";